export enum EvaluationQuestionType {
  PASS_FAIL = 'PASS_FAIL',
  SCORE = 'SCORE'
}
